import { createRouter, createWebHistory } from 'vue-router';
import ecomRoutes from './ecomRoutes';
import ecomCmsRoutes from './ecomCmsRoutes';
//import dynamicRoutes from './dynamicRoutes';
import {formatUrlForCachedFiles} from "@/global/modules/functions.js";
import ProductsList from '@/ecom/views/pages/ProductsList.vue';
import Product from '@/ecom/views/pages/Product.vue';
import DynamicPage from '@/global/views/DynamicPage.vue';

const routes = [
    ...ecomRoutes,
    ...ecomCmsRoutes,
    //...dynamicRoutes,
    {path: '/access-denied', name: 'AccessDenied',component: () => import('@/global/views/AccessDenied.vue')},
    // {path: '/:pathMatch(.*)*', name: 'ProductListingPage', component: () => import('@/ecom/views/pages/ProductsList.vue') },
    // {path: '/:pathMatch(.*)*', name: 'ProductDetailPage', component: () => import('@/ecom/views/pages/Product.vue') },
    // {path: '/:pathMatch(.*)*', name: 'DynamicPage', component: () => import('@/global/views/DynamicPage.vue') },
    // {path: '/:pathMatch(.*)*', name: 'NotFound', component: () => import('@/global/views/NotFound.vue') },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior(to, from, savedPosition) { //Automatically go to last scroll position when going back/forward
        return new Promise((resolve, reject) => {
            if(savedPosition) {
                // create an Observer instance of the body - when the body size changes (e.g. when the dynamic content has loaded) scroll to last position
                const resizeObserver = new ResizeObserver(entries => {
                    if(entries[0].target.clientHeight >= savedPosition.top + screen.height) {
                        resolve(savedPosition);
                        resizeObserver.disconnect();
                    }
                });
                
                resizeObserver.observe(document.body);
            } 
            else{
                resolve({ top: 0 }); //If previous saved position not available always reset to 0
            }
        });
    }
})

async function dynamicRouting(to){
    try{
        let formatted_route = formatUrlForCachedFiles(to.path);

        const response = await fetch(`/cached_routes/${formatted_route}.json`);

        if (!response.ok){
            throw new Error('Route not found');
        }

        const route = await response.json();

        console.log(route)

        // if(route.type == 'plp'){
        //     router.addRoute({ path: to.path, component: ProductsList })
        //     router.replace(router.currentRoute.value.fullPath);
        // }

        // if(route.type == 'pdp'){
        //     router.addRoute({ path: to.path, component: Product })
        //     router.replace(router.currentRoute.value.fullPath);
        // }

        // if(route.type == 'dyn'){
            router.addRoute({ path: to.path, component: DynamicPage })
            router.replace(router.currentRoute.value.fullPath);
        // }

        return;
    }
    catch(e){
        let valid_route = false;

        for (let i = 0; i < router.options.routes.length; i++) {
            if(router.options.routes[i].name == to.name){
                valid_route = true;
                break;
            }
        }

        if(!valid_route){
            router.addRoute({ path: to.path, component: () => import('@/global/views/NotFound.vue') })
            router.replace(router.currentRoute.value.fullPath);
        }
    }
}

router.beforeEach((to, from) => {
    dynamicRouting(to);
});

export default router